export const BRAND = {
  name: "ChiCha Lounge",
  tagline: "Washington DC's Premier Hookah Lounge",
  address: "1214 U St NW, Washington, DC 20009",
  addressShort: "1214 U St NW",
  city: "Washington, DC 20009",
  phone: "(202) 607-1983",
  phoneRaw: "+12026071983",
  email: "reservations@dcchicha.com",
  instagram: "https://www.instagram.com/chichalounge/",
  mapsQuery: "1214 U St NW, Washington, DC 20009",
  googleMaps: "https://www.google.com/maps/place/chicha+dc/data=!4m2!3m1!1s0x89b7b720ad38794d:0x5a199b30d5c0d813",
  logo: "https://customer-assets-jai6qajn.emergentagent.net/job_luxury-lounge-dc-1/artifacts/p8m008rp_IMG_4743-102w.webp",
};

export const HOURS = [
  { day: "Monday", time: "5:00 PM – 2:00 AM" },
  { day: "Tuesday", time: "5:00 PM – 2:00 AM" },
  { day: "Wednesday", time: "5:00 PM – 2:00 AM" },
  { day: "Thursday", time: "5:00 PM – 3:00 AM" },
  { day: "Friday", time: "5:00 PM – 3:00 AM" },
  { day: "Saturday", time: "2:00 PM – 3:00 AM" },
  { day: "Sunday", time: "2:00 PM – 2:00 AM" },
];

export const NAV = [
  { label: "Home", to: "/" },
  { label: "Events", to: "/events" },
  { label: "Reservations", to: "/reservations" },
  { label: "VIP Tables", to: "/vip-tables" },
  { label: "Menus", to: "/menus", desc: "Food · Drinks · Cocktails" },
  { label: "Private Events", to: "/private-events" },
  { label: "Gallery", to: "/gallery" },
  { label: "Blog", to: "/blog" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

const A = "https://customer-assets-jai6qajn.emergentagent.net/job_luxury-lounge-dc-1/artifacts/";
export const VENUE = {
  serverCocktail: A + "8gstyymt_IMG_1756.jpeg",
  hookahSpecialist: A + "7fas1sjs_IMG_1757.jpeg",
  crowdBubbles2: A + "8d7vuf1l_IMG_1758.jpeg",
  groupBrick: A + "pqcptcpt_IMG_1759.jpeg",
  banquetteWomen: A + "139svwi6_IMG_1760.jpeg",
  chichaSign: A + "jdm3visx_IMG_1761.jpeg",
  bottleBubbles: A + "iakygdj6_IMG_1762.jpeg",
  sundayFunday: A + "p03ibpte_IMG_1763.jpeg",
  peaceGirls: A + "kkbxu2wp_IMG_1764.jpeg",
  loungeGirls: A + "bh89ywyp_IMG_1765.jpeg",
};
export const IMAGES = {
  heroPoster: VENUE.banquetteWomen,
  lounge: VENUE.chichaSign,
  hookah1: VENUE.banquetteWomen,
  hookah2: VENUE.hookahSpecialist,
  cocktail1: VENUE.serverCocktail,
  cocktail2: "https://images.unsplash.com/photo-1770164491578-09f08156db2d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  cocktail3: "https://images.pexels.com/photos/8084688/pexels-photo-8084688.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1200",
  bottle: VENUE.bottleBubbles,
  crowd: VENUE.groupBrick,
  dj: VENUE.crowdBubbles2,
  food1: "https://images.unsplash.com/photo-1692197275441-40c874f40385?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  food2: "https://images.unsplash.com/photo-1519077336050-4ca5cac9d64f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  marbleBar: VENUE.groupBrick,
  partyGirls: VENUE.peaceGirls,
};

export const HOOKAH_FLAVORS = [
  "Orange Mint", "Gum Mint", "Watermelon Mint", "Mint", "Vanilla", "Mango",
  "Blueberry Mint", "Love 66", "Blue Mist", "Pineapple", "Guava", "Lady Killer",
  "Double Apple", "Kiwi", "Lemon", "Peach", "Strawberry", "Melon", "Grape",
  "Mighty Freeze", "Mojito", "Rose", "Mi Amor",
];

export const HOOKAH_SPECIALS = [
  { label: "Tuesday — All Night", price: "$30" },
  { label: "Wed–Fri · 5PM–9PM", price: "$25" },
  { label: "Sat–Sun · 2PM–9PM", price: "$30" },
  { label: "After 10 PM", price: "$50" },
];

export const COCKTAILS = [
  { name: "The Dre Connection", price: "$18", desc: "Cognac's warmth elegantly combined with amaretto's sweet depth — a simple yet sophisticated taste experience.", ingredients: "Cognac, amaretto" },
  { name: "Cardozo Citrus Rise", price: "$18", desc: "A picturesque sunrise over the historic Cardozo area — a symphony of layered colors and refreshing citrus.", ingredients: "Orange juice, grapefruit juice, a splash of lime, silver tequila, a hint of grenadine for color" },
  { name: "U Street Sidekick", price: "$18", desc: "The rhythmic soul of U Street — flavors as diverse and harmonious as the neighborhood's musical legacy.", ingredients: "Bourbon, lemon juice, simple syrup, a float of red wine" },
  { name: "Shawhattan", price: "$18", desc: "A tribute to Shaw's rich cultural tapestry — a twist on the classic Manhattan.", ingredients: "Rye whiskey, sweet vermouth, a dash of bitters, cherry garnish, cherry blossom liqueur" },
  { name: "202 Fizz", price: "$18", desc: "Celebrating the heartbeat of D.C. — lively bubbles and a spirited blend.", ingredients: "Gin, lemon juice, simple syrup, sparkling water, a twist of lemon" },
  { name: "District Cosmo", price: "$18", desc: "Sophisticated and cosmopolitan — reflecting the District's diverse culture and vibrant social scene.", ingredients: "Vodka, triple sec, cranberry juice, freshly squeezed lime juice, an orange twist" },
  { name: "Columbia Sangría", price: "$18", desc: "A colorful sangria mirroring the District's melting pot — perfect for celebrations of unity.", ingredients: "Red wine, brandy, orange juice, mixed fresh fruits, a splash of soda for effervescence" },
  { name: "Capitol Zest", price: "$18", desc: "A lively, zesty twist on the nation's hub — bright flavors and a spirited character.", ingredients: "Vodka, triple sec, lemon juice, simple syrup, a sugared rim and a twist of lemon" },
  { name: "Shaw-jito", price: "$18", desc: "A minty, invigorating mojito with the historic charm of Shaw.", ingredients: "White rum, fresh lime juice, mint leaves, simple syrup, soda water, a sprig of mint" },
  { name: "Black Broadway Brew", price: "$18", desc: "A tribute to U Street's musical and cultural heritage — as spirited as the district's storied past.", ingredients: "Dark rum, coffee liqueur, a shot of espresso, a dash of simple syrup, a twist of orange" },
  { name: "Chi-Cha Chiller", price: "$18", desc: "Inspired by the cool vibes of the Chi-Cha Lounge — our take on the Moscow Mule.", ingredients: "Vodka, ginger beer, lime juice, served in a copper mug with a slice of lime" },
  { name: "Stormy Shaw Skies", price: "$18", desc: "Bold and flavorful, reflecting the resilience and spirit of the Shaw district.", ingredients: "Dark rum, ginger beer, lime juice, a float of blackberry liqueur" },
  { name: "An Old Fashioned", price: "$18", desc: "A timeless classic — simple, balanced and refined.", ingredients: "Bourbon or rye whiskey, a touch of sugar, bitters, a twist of citrus, cherry or orange garnish" },
];

export const FOOD = [
  { name: "Wings & Cajun Fries", desc: "Jerk, Mumbo, Lemon Pepper or Cajun · with Cajun fries", price: "$22" },
  { name: "Steak Suya Strips, Jollof Rice & Cabbage", desc: "West African spiced steak strips, jollof rice & sautéed cabbage", price: "$28" },
  { name: "Cajun Fried Fish Sandwich & Fries", desc: "", price: "$18" },
  { name: "Fried Shrimp Basket", desc: "", price: "$18" },
  { name: "Cajun Creamy Pasta", desc: "Beef andouille · add Chicken +$10 · add Fried Lamb Chops +$12", price: "$16" },
  { name: "Jerk Chicken Sliders (3)", desc: "", price: "$16" },
  { name: "Smash Burger Sliders (3)", desc: "", price: "$14" },
  { name: "Calamari", desc: "", price: "$12" },
  { name: "Chopped Kale Caesar", desc: "", price: "$10" },
];

export const FOOD_SIDES = [
  { name: "Cajun Fries", price: "$10" },
  { name: "Cabbage", price: "$10" },
  { name: "Jollof Rice", price: "$10" },
];

export const FOOD_HAPPY_HOUR = [
  { name: "Wings", price: "$10" },
  { name: "Sliders", price: "$12" },
  { name: "Fries", price: "$6" },
  { name: "Calamari", price: "$8" },
];

export const HAPPY_HOUR = [
  { name: "Old Fashioned", price: "$10" },
  { name: "Lemon Drop", price: "$10" },
  { name: "Margarita", price: "$10" },
  { name: "Shots", price: "$8" },
];

export const PRIVATE_EVENT_TYPES = [
  "Birthday Party", "Corporate Event", "Networking Mixer", "Holiday Party",
  "Graduation", "Bachelor / Bachelorette", "VIP Celebration", "Other",
];

export const WHY = [
  { title: "Premium Hookah", desc: "20+ flavors & custom house mixes crafted by specialists." },
  { title: "Craft Cocktails", desc: "A DC-inspired cocktail program rivaling the city's best bars." },
  { title: "Live DJs", desc: "The District's top DJs spinning afrobeats, hip-hop & house." },
  { title: "VIP Experience", desc: "Bottle service, reserved sections & white-glove hospitality." },
  { title: "Luxury Atmosphere", desc: "Matte-black interiors, amber lighting & velvet seating." },
  { title: "On U Street", desc: "In the heart of DC's most storied nightlife corridor." },
];

export const STATS = [
  { value: 20, suffix: "+", label: "Hookah Flavors" },
  { value: 13, suffix: "", label: "Signature Cocktails" },
  { value: 15, suffix: "K+", label: "Nights Made Unforgettable" },
  { value: 5, suffix: "★", label: "Average Guest Rating" },
];
